<template>
  <div>
    <p style="font-weight: bold; text-decoration: underline;">
      Updated Sunday, September 9th 2018
    </p>
    <p>
      We will be adding pictures and descriptions of jobs that Euro Precast Concrete has completed throughout the
      Southern California region on this new site shortly. Check back soon!
    </p>
  </div>
</template>

<script>
  export default {
    name: "Construction"
  }
</script>

<style scoped>

</style>